module.exports = __webpack_public_path__ + "media/BLITZ.3917e5f4.mp4";